/*
 * @Date: 2021-11-19 14:47:18
 * @Description: desc
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Download from '@/views/Download.vue';
import DownloadStudent from '@/views/DownloadStudent.vue';
import DownloadTeacher from '@/views/DownloadTeacher.vue';
import BooksDownload from '@/views/BooksDownload/index';
import privacyPolicy from '@/views/privacyPolicy.vue';
import studentPrivacyPolicy from '@/views/studentPrivacyPolicy.vue';

import userAgreement from '@/views/userAgreement.vue';

import helperInfo from '@/views/pubilc/helperInfo.vue';
import CancelExplain from '@/views/CancelExplain.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '听力',
    },
  },
  {
    path: '/download',
    name: 'download',
    component: Download,
    meta: {
      title: '新教育',
    },
  },
  {
    path: '/download/student',
    name: 'download_student',
    component: DownloadStudent,
    meta: {
      title: '新教育-App下载',
    },
  },
  {
    path: '/download/tercher',
    name: 'download_tercher',
    component: DownloadTeacher,
    meta: {
      title: '新教育-App下载',
    },
  },
  {
    path: '/books/download',
    name: 'books_download',
    component: BooksDownload,
    meta: {
      title: '下载资源包',
    },
  },
  {
    path: '/privacyPolicy',
    name: 'privacy_policy',
    component: privacyPolicy,
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/studentPrivacyPolicy',
    name: 'student_privacyPolicy',
    component: studentPrivacyPolicy,
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/userAgreement',
    name: 'user_agreement',
    component: userAgreement,
    meta: {
      title: '用户协议',
    },
  },
  {
    path: '/public/helperInfo',
    name: 'heler_info',
    component: helperInfo,
    meta: {
      title: '批阅帮助',
    },
  },
  {
    path: '/cancelExplain',
    name: 'cancel-explain',
    component: CancelExplain,
    meta: {
      title: '自愿申请注销新教育账号的说明',
    },
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    // 备课详情title改变
    document.title = to.meta.title;
  } else {
    document.title = '新教育智能平台 - 中国智能化教育领导者';
  }
  next();
});

export default router;
